export const IconType = {
	solid: 'solid',
	regular: 'regular',
	light: 'light',
	thin: 'thin',
	duotone: 'duotone',
	brands: 'brands',
	fak: 'fak',
	sharp: 'sharp',
	kit: 'kit',
} as const;
export type IconType = (typeof IconType)[keyof typeof IconType];

export const IconSize = {
	_2xs: '2xs',
	_xs: 'xs',
	_sm: 'sm',
	_lg: 'lg',
	_xl: 'xl',
	_2xl: '2xl',
	_1x: '1x',
	_2x: '2x',
	_3x: '3x',
	_4x: '4x',
	_5x: '5x',
	_6x: '6x',
	_7x: '7x',
	_8x: '8x',
	_9x: '9x',
	_10x: '10x',
} as const;
export type IconSize = (typeof IconSize)[keyof typeof IconSize];

export enum FaIconSize {
	xxs = '2xs',
	xs = 'xs',
	sm = 'sm',
	lg = 'lg',
	xl = 'xl',
	xxl = '2xl',
}

export type DcIconStruct = {
	name: string;
	type: IconType;
	size: IconSize;
	color?: string;
	primaryColor?: string;
	primaryOpacity?: number;
	secondaryColor?: string;
	secondaryOpacity?: number;
	transform?: string;
	styles?: object;
	class?: string;
	autoFlip?: 'x' | 'y' | 'both';
};
